import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeleteProjectDocumentEngineTemplates = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['deleteProjectDocumentEngineTemplates']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectKeys.deleteProjectDocumentEngineTemplates,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.byId({ projectId: variables.projectId })._ctx
          .projectDocumentEngineTemplates._def,
      })
    },
  })
}
